import React, { useEffect } from "react";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { GeneralTable } from "../GeneralComponents";
import { CardBody } from "reactstrap";
import { IconButton, Modal } from "@material-ui/core";
import CloseIcon from "mdi-react/CloseIcon";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "start", // Vertical centering
    whiteSpace: "pre-wrap", // Tries to keep the text on a single line
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function TabletConsultDocumentos() {
  const classes = useStyles();
  const [documentoSeleccionado, setDocumentoSeleccionado] =
    React.useState(null);
  const [loadDependencias, setLoadDependencias] = React.useState([]);
  const [documentos, setDocumentos] = React.useState([]);
  const [showPdf, setShowPdf] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);

  useEffect(() => {
    loadDocumentos();
  }, [page, pageSize]);

  const columns = [
    {
      field: "fecha_creacion",
      headerName: "FECHA CREACIÓN",
      type: "date",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueFormatter: (params) =>
        params.value ? moment(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "version",
      headerName: "VERSIÓN",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_documento",
      headerName: "NOMBRE DEL DOCUMENTO",
      type: "string",
      flex: 2,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "sistema_gestion",
      headerName: "SISTEMA DE GESTIÓN",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "nombre_dependencia",
      headerName: "DEPENDENCIA/PRODUCTORA",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
    },
    /* {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
         valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    }, */
  ];

  async function handleSaveNewSerie() {}

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const onActivate = (row) => {};
  const onInactivate = (row) => {};

  const onUpdate = (row) => {};

  const actionsList = [
    {
      title: "Ver documento",
      ariaLabel: "view-document",
      icon: <PictureAsPdfIcon />,
      onClick: (row) => {
        setDocumentoSeleccionado(row);
        setShowPdf(true);
      },
      //show: (row) => !!row, // Puedes controlar visibilidad
    },
  ];

  const loadDocumentos = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL +
        `documento/listar?page=${page + 1}&page_size=${pageSize}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setDocumentos(data.results);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      <CardBody style={{ padding: 30 }}>
        <GeneralTable
          title=""
          titleAlert="Documentos"
          columns={columns}
          rows={documentos}
          onSaveModal={handleSaveNewSerie}
          actionsList={actionsList}
          onActivate={onActivate}
          onInactivate={onInactivate}
          onUpdate={onUpdate}
          enableUpdate={false}
          enableDocumentarytype={false}
          enableView={false}
          rowCount={rowCount}
          pageSize={pageSize}
          page={page}
          handlePageChange={handlePageChange}
          handlePageSizeChange={handlePageSizeChange}
          isModalDocument={true}
        />
      </CardBody>
      {showPdf ? (
        <Modal
          open={showPdf}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          style={{ zIndex: 1000 }}
        >
          <div
            className="paperAppointment-flex"
            style={{ width: "100%", margin: 10 }}
          >
            <IconButton
              style={{ float: "right" }}
              onClick={() => {
                setShowPdf(false);
              }}
            >
              <CloseIcon />
            </IconButton>
            <iframe
              id="pdfV"
              width="1000"
              height="700"
              src={
                process.env.REACT_APP_PUBLIC_URL +
                "documento/ver/" +
                documentoSeleccionado.id_gd_documentos +
                "/" +
                sessionStorage.getItem("token")
              }
            ></iframe>
          </div>
        </Modal>
      ) : null}
    </>
  );
}
